import { useRecoilValue, useSetRecoilState } from 'recoil';
import { userAccountUsdtBalance, userSmartAccountUsdtBalance, userSmartAccountRainBalance, userSmartAccount, userSmartAccountLegacyUsdtBalance } from './RecoilAtom';
import { usdt_token } from '../utils/Enviroment';
import { USDT_DECIMALS } from '../utils/constants';
import useBalance from '../hooks/dataFetcher/BalanceOf';
import { useCallback } from 'react';
import { useEoaAccount } from '../hooks/useEoaAccount';
// import { useWeb3React } from '@web3-react/core';

export const useGetAllBalances = () => {
    const { BalanceHook, getRainBalance, getTokenBalance } = useBalance();
    const setAccountUsdtBalance = useSetRecoilState(userAccountUsdtBalance);
    const setSmartAccountUsdtBalance = useSetRecoilState(userSmartAccountUsdtBalance);
    const setSmartAccountRainBalance = useSetRecoilState(userSmartAccountRainBalance);
    const setSmartAccountLegacyUsdtBalance = useSetRecoilState(userSmartAccountLegacyUsdtBalance);
    const smartAccount = useRecoilValue(userSmartAccount);
    const { account } = useEoaAccount()

    const getAllBalances = useCallback(async () => {
        if (account) {
            try {
                const mainUsdtBalance = await BalanceHook(account);
                setAccountUsdtBalance(mainUsdtBalance);
            } catch (error) {
                console.error("Failed to fetch balance for main account:", error);
            }
        }
        if (smartAccount) {
            try {
                const smartUsdtBalance = await BalanceHook(smartAccount);
                setSmartAccountUsdtBalance(smartUsdtBalance);
                const smartRainBalance = await getRainBalance(smartAccount);
                setSmartAccountRainBalance(smartRainBalance);
                const smartLegacyUsdtBalance = await getTokenBalance(usdt_token, smartAccount, USDT_DECIMALS);
                setSmartAccountLegacyUsdtBalance(smartLegacyUsdtBalance);
            } catch (error) {
                console.error("Failed to fetch balance for smart account:", error);
            }
        }
    }, [account, smartAccount]);

    return getAllBalances;
};